<template>
  <div class="registerOrLogin">
    <LoginForm />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from '@/components/login/LoginForm.vue'

export default {
  name: 'RegisterOrLogin',
  components: {
    LoginForm
  }
}
</script>
